<div class="account-info">
    <h4 class="custom-section-title">{{'ACCOUNT.ACCOUNT_INFO' | translate}}</h4>
    <p *ngIf="infoLoaded">{{'ACCOUNT.TYPE' | translate}}: {{ (userRole === 'client' ? 'LOGIN.COMPANY' : 'LOGIN.CANDIDATE') | translate }}</p>
    <p *ngIf="infoLoaded && userRole === 'client'">
        {{'ACCOUNT.COMPANY_NAME' | translate}}: {{company.companyName}}
    </p>
    <p>{{'LOGIN.LAST_NAME' | translate}}: {{userData.lastName}}</p>
    <p>{{'LOGIN.FIRST_NAME' | translate}}: {{userData.firstName}} </p>
    <p>Email: {{userData.email}} </p>
    <p>{{'LOGIN.CITY' | translate}}: {{userData.city}}</p>
    <p>{{'LOGIN.COUNTRY' | translate}}: {{userData.userCountry}}</p>
    <p>{{'LOGIN.ADDRESS' | translate}}: {{userData.address}}</p>
</div>
